export default __webpack_public_path__ + "662f151385749b7453d66265c389f9e8.svg";